export default __webpack_public_path__ + "3d1d78f.png";